export default __webpack_public_path__ + "static/6-710591fd68ce797727c04341e9002da3.jpg";